import { useEffect, useState } from "react";
import { Loading } from "./Loading";
import { Box, CircularProgress, Typography } from "@mui/material";

function LoaderBox({ isLoading, children }) {
  const [endLoad, setEndLoad] = useState(true);

  if (isLoading === undefined) {
    setTimeout(() => {
      setEndLoad(false);
    }, 900);
  }

  useEffect(() => {
    setTimeout(() => {
      setEndLoad(false);
    }, 900);
  }, [isLoading]);

  if (endLoad) {
    return <Loading />;
  } else {
    return <>{children}</>;
  }
}

function LoaderBoxCircular({ isLoading, loadingText, children }) {
  return isLoading ? (
    <Box sx={{ textAlign: 'center', marginTop: 4 }}>
      <CircularProgress />
      {loadingText && <Typography sx={{ mt: 2 }}>{loadingText}</Typography>}
    </Box>
  ) : (
    children
  );
}
export { LoaderBox, LoaderBoxCircular };
